"use client";
import { css as t } from "@emotion/react";
import { opacity as n } from "../../../helpers/color/color.js";
import { COLORS as s } from "../../../tokens/colors/Colors.js";
const m = (o, r) => t`
	background: ${o && n(s.black, 0.4)};
	transition: background ${r}ms ease-in;
	transition-delay: ${!o && `${r}ms`}; /* Delays transition onClose */
`;
export {
  m as overlay
};
